// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiErrorAPIModel,
    ApiErrorAPIModelFromJSON,
    ApiErrorAPIModelToJSON,
    DiscoveredBanksAPIModel,
    DiscoveredBanksAPIModelFromJSON,
    DiscoveredBanksAPIModelToJSON,
    FpsTransferAPIModel,
    FpsTransferAPIModelFromJSON,
    FpsTransferAPIModelToJSON,
    GetReceiverNameAPIModel,
    GetReceiverNameAPIModelFromJSON,
    GetReceiverNameAPIModelToJSON,
    NewBanksDiscoveryAPIModel,
    NewBanksDiscoveryAPIModelFromJSON,
    NewBanksDiscoveryAPIModelToJSON,
    NewFpsTransferAPIModel,
    NewFpsTransferAPIModelFromJSON,
    NewFpsTransferAPIModelToJSON,
    NewPreparedFpsTransferAPIModel,
    NewPreparedFpsTransferAPIModelFromJSON,
    NewPreparedFpsTransferAPIModelToJSON,
    PreparedFpsTransferAPIModel,
    PreparedFpsTransferAPIModelFromJSON,
    PreparedFpsTransferAPIModelToJSON,
    WrappedFpsReceiverNameAPIModel,
    WrappedFpsReceiverNameAPIModelFromJSON,
    WrappedFpsReceiverNameAPIModelToJSON,
} from '../models';

export interface FpsDiscoverBanksRequest {
    newBanksDiscoveryAPIModel: NewBanksDiscoveryAPIModel;
}

export interface FpsGetReceiverNameRequest {
    getReceiverNameAPIModel: GetReceiverNameAPIModel;
}

export interface FpsPrepareTransferRequest {
    newPreparedFpsTransferAPIModel: NewPreparedFpsTransferAPIModel;
}

export interface FpsTransferRequest {
    newFpsTransferAPIModel: NewFpsTransferAPIModel;
}

/**
 * FpsApi - interface
 * 
 * @export
 * @interface FpsApiInterface
 */
export interface FpsApiInterface {
    /**
     * Returns list of banks that support FPS
     * @param {NewBanksDiscoveryAPIModel} newBanksDiscoveryAPIModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FpsApiInterface
     */
    fpsDiscoverBanksRaw(requestParameters: FpsDiscoverBanksRequest): Promise<runtime.ApiResponse<DiscoveredBanksAPIModel>>;

    /**
     * Returns list of banks that support FPS
     */
    fpsDiscoverBanks(newBanksDiscoveryAPIModel: NewBanksDiscoveryAPIModel): Promise<DiscoveredBanksAPIModel>;

    /**
     * Returns FPS receiver name
     * @param {GetReceiverNameAPIModel} getReceiverNameAPIModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FpsApiInterface
     */
    fpsGetReceiverNameRaw(requestParameters: FpsGetReceiverNameRequest): Promise<runtime.ApiResponse<WrappedFpsReceiverNameAPIModel>>;

    /**
     * Returns FPS receiver name
     */
    fpsGetReceiverName(getReceiverNameAPIModel: GetReceiverNameAPIModel): Promise<WrappedFpsReceiverNameAPIModel>;

    /**
     * Prepares FPS transfer to be performed
     * @param {NewPreparedFpsTransferAPIModel} newPreparedFpsTransferAPIModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FpsApiInterface
     */
    fpsPrepareTransferRaw(requestParameters: FpsPrepareTransferRequest): Promise<runtime.ApiResponse<PreparedFpsTransferAPIModel>>;

    /**
     * Prepares FPS transfer to be performed
     */
    fpsPrepareTransfer(newPreparedFpsTransferAPIModel: NewPreparedFpsTransferAPIModel): Promise<PreparedFpsTransferAPIModel>;

    /**
     * Performs FPS transfer
     * @param {NewFpsTransferAPIModel} newFpsTransferAPIModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FpsApiInterface
     */
    fpsTransferRaw(requestParameters: FpsTransferRequest): Promise<runtime.ApiResponse<FpsTransferAPIModel>>;

    /**
     * Performs FPS transfer
     */
    fpsTransfer(newFpsTransferAPIModel: NewFpsTransferAPIModel): Promise<FpsTransferAPIModel>;

}

/**
 * 
 */
export class FpsApi extends runtime.BaseAPI implements FpsApiInterface {

    /**
     * Returns list of banks that support FPS
     */
    async fpsDiscoverBanksRaw(requestParameters: FpsDiscoverBanksRequest): Promise<runtime.ApiResponse<DiscoveredBanksAPIModel>> {
        if (requestParameters.newBanksDiscoveryAPIModel === null || requestParameters.newBanksDiscoveryAPIModel === undefined) {
            throw new runtime.RequiredError('newBanksDiscoveryAPIModel','Required parameter requestParameters.newBanksDiscoveryAPIModel was null or undefined when calling fpsDiscoverBanks.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fps/discover-banks`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewBanksDiscoveryAPIModelToJSON(requestParameters.newBanksDiscoveryAPIModel),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscoveredBanksAPIModelFromJSON(jsonValue));
    }

    /**
     * Returns list of banks that support FPS
     */
    async fpsDiscoverBanks(newBanksDiscoveryAPIModel: NewBanksDiscoveryAPIModel): Promise<DiscoveredBanksAPIModel> {
        const response = await this.fpsDiscoverBanksRaw({ newBanksDiscoveryAPIModel: newBanksDiscoveryAPIModel });
        return await response.value();
    }

    /**
     * Returns FPS receiver name
     */
    async fpsGetReceiverNameRaw(requestParameters: FpsGetReceiverNameRequest): Promise<runtime.ApiResponse<WrappedFpsReceiverNameAPIModel>> {
        if (requestParameters.getReceiverNameAPIModel === null || requestParameters.getReceiverNameAPIModel === undefined) {
            throw new runtime.RequiredError('getReceiverNameAPIModel','Required parameter requestParameters.getReceiverNameAPIModel was null or undefined when calling fpsGetReceiverName.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fps/resolve-name`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetReceiverNameAPIModelToJSON(requestParameters.getReceiverNameAPIModel),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => WrappedFpsReceiverNameAPIModelFromJSON(jsonValue));
    }

    /**
     * Returns FPS receiver name
     */
    async fpsGetReceiverName(getReceiverNameAPIModel: GetReceiverNameAPIModel): Promise<WrappedFpsReceiverNameAPIModel> {
        const response = await this.fpsGetReceiverNameRaw({ getReceiverNameAPIModel: getReceiverNameAPIModel });
        return await response.value();
    }

    /**
     * Prepares FPS transfer to be performed
     */
    async fpsPrepareTransferRaw(requestParameters: FpsPrepareTransferRequest): Promise<runtime.ApiResponse<PreparedFpsTransferAPIModel>> {
        if (requestParameters.newPreparedFpsTransferAPIModel === null || requestParameters.newPreparedFpsTransferAPIModel === undefined) {
            throw new runtime.RequiredError('newPreparedFpsTransferAPIModel','Required parameter requestParameters.newPreparedFpsTransferAPIModel was null or undefined when calling fpsPrepareTransfer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fps/prepare-transfer`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewPreparedFpsTransferAPIModelToJSON(requestParameters.newPreparedFpsTransferAPIModel),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => PreparedFpsTransferAPIModelFromJSON(jsonValue));
    }

    /**
     * Prepares FPS transfer to be performed
     */
    async fpsPrepareTransfer(newPreparedFpsTransferAPIModel: NewPreparedFpsTransferAPIModel): Promise<PreparedFpsTransferAPIModel> {
        const response = await this.fpsPrepareTransferRaw({ newPreparedFpsTransferAPIModel: newPreparedFpsTransferAPIModel });
        return await response.value();
    }

    /**
     * Performs FPS transfer
     */
    async fpsTransferRaw(requestParameters: FpsTransferRequest): Promise<runtime.ApiResponse<FpsTransferAPIModel>> {
        if (requestParameters.newFpsTransferAPIModel === null || requestParameters.newFpsTransferAPIModel === undefined) {
            throw new runtime.RequiredError('newFpsTransferAPIModel','Required parameter requestParameters.newFpsTransferAPIModel was null or undefined when calling fpsTransfer.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/fps/transfers`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NewFpsTransferAPIModelToJSON(requestParameters.newFpsTransferAPIModel),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => FpsTransferAPIModelFromJSON(jsonValue));
    }

    /**
     * Performs FPS transfer
     */
    async fpsTransfer(newFpsTransferAPIModel: NewFpsTransferAPIModel): Promise<FpsTransferAPIModel> {
        const response = await this.fpsTransferRaw({ newFpsTransferAPIModel: newFpsTransferAPIModel });
        return await response.value();
    }

}
